/* @ngInject */
const axletreeGo = (
  $state,
  routes,
  wagonLocal
) => {
  const self = {}

  self.edit = (_id) => {
    wagonLocal.saveCurrentScrappedId(_id)
    $state.go(routes.scrapping.sale.axletrees.path)
  }

  return self
}
export default axletreeGo



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/services/go.service.js